import * as $ from 'jquery';
import { CarouselCommon } from './carousel-common';

export class CarouselFrontend {

    static init() {
        $(document).ready(() => {
            $('.carousel-component .component-carousel').each((i, cr) => {
                let carousel = $(cr);
                let itemsPerPage = carousel.parent().attr('data-items-per-page');
                CarouselCommon.initSlick(carousel, itemsPerPage);
                CarouselCommon.subscribeResize(() => CarouselCommon.initSlick(carousel, itemsPerPage));
            })
            CarouselCommon.disableSlickDrag();
        });
    }
}